import ControlViewModel from '@/ViewModels/ControlViewModel';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';

export default class TreeViewItemViewModel extends ControlViewModel {

    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModel>('LinkViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModel>('ImageViewModel');

    /**
     * Gibt an, ob das Item geöffnet ist
     */
    public isExpanded: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob das Item ein Favoritenlink ist und definiert dessen Link-Adresse
     */
    public favoriteAddress: KnockoutObservable<any>;

    /**
     * Gibt an, ob das Item selektiert ist
     */
    public isSelected: KnockoutObservable<boolean>;

    /**
     * Enthält den Link
     */
    public link: LinkViewModel;

    /**
     * Enthält den Link zum Entfernen eines Favoriteneintrags
     */
    public removeFavorite: LinkViewModel;

    /**
     * Ein Callback, welcher aufgerufen wird, wenn mit der Tastatur navigiert wird
     */
    public onNavigate: any;

    /**
     * Enthält die Kindelemente
     */
    public items: KnockoutObservable<Array<TreeViewItemViewModel>>;
    public hasVisibleChildren: KnockoutComputed<boolean>;

    /**
     * Das ViewModel für ein TreeViewItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.isExpanded = this.observableOrDefault(params.isExpanded, false);
        this.favoriteAddress = this.observableOrDefault(params.favoriteAddress, null);
        this.isSelected = this.observableOrDefault(params.isSelected, false);
        this.link = this.paramOrDefault(params.link, null);
        this.removeFavorite = this.paramOrDefault(() => {
            if (this.favoriteAddress() != null) {
                return new this.LinkViewModel({
                    onClick: () => {
                        let favorites = RADApplication.getInstance().user.getUserSpecificData('RAD_FAVOURITESITES', {})();
                        let address = this.favoriteAddress();

                        delete favorites[address];
                        RADApplication.getInstance().user.setUserSpecificData('RAD_FAVOURITESITES', favorites);
                    },
                    isVisible: RADApplication.getInstance().isRADlicensed
                });
            }

            return null;
        })();

        this.onNavigate = this.handlerOrDefault(params.onNavigate);
        this.items = this.observableOrDefault(params.items, []);

        this.hasVisibleChildren = this.defineComputed(() => {
            return this.items().some((child: TreeViewItemViewModel) => {
                return child.isVisible() === true;
            });
        });
    }
}

ComponentManager.setViewModel('TreeViewItemViewModel', TreeViewItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');